import React from 'react';
export const TestimonialsSection = () => {
  return <section className="mb-10" data-id="element-190">
      <div className="bg-white p-6 border border-gray-200 rounded-lg" data-id="element-191">
        <h2 className="text-3xl font-bold text-blue-800 mb-6" data-id="element-192">
          The stories that prove this isn't just another pillow
        </h2>
        <p className="mb-6 text-gray-700 text-lg" data-id="element-193">
          What convinced me that Relievana™ was different were the stories from
          people whose experiences mirrored my own desperate journey:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-194">
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-195">
            <div className="flex items-center mb-3" data-id="element-196">
              <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Linda M." className="w-14 h-14 rounded-full object-cover mr-3" data-id="element-197" />
              <div data-id="element-198">
                <p className="font-bold text-gray-800 text-lg" data-id="element-199">
                  Linda M., Age 52
                </p>
                <div className="flex text-yellow-500 text-xl" data-id="element-200">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg" data-id="element-201">
              "I haven't been able to stand up straight for months. My doctor
              said hip replacement surgery was the only option left. I ordered
              Relievana™ as a last resort before going under the knife. Three
              weeks later, I'm gardening again and surgery is off the table. I
              wish I'd found this sooner – all that wasted time suffering."
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-202">
            <div className="flex items-center mb-3" data-id="element-203">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80" alt="James R." className="w-14 h-14 rounded-full object-cover mr-3" data-id="element-204" />
              <div data-id="element-205">
                <p className="font-bold text-gray-800 text-lg" data-id="element-206">
                  James R., Age 44
                </p>
                <div className="flex text-yellow-500 text-xl" data-id="element-207">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg" data-id="element-208">
              "Truck driver for 15 years, and the sciatica was getting so bad I
              thought I'd have to change careers. My wife ordered this pillow
              after watching me struggle to get out of bed every morning. The
              shooting pain down my leg is completely gone. I'm back to feeling
              like myself again."
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-209">
            <div className="flex items-center mb-3" data-id="element-210">
              <img src="https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80" alt="Patricia K." className="w-14 h-14 rounded-full object-cover mr-3" data-id="element-211" />
              <div data-id="element-212">
                <p className="font-bold text-gray-800 text-lg" data-id="element-213">
                  Patricia K., Age 68
                </p>
                <div className="flex text-yellow-500 text-xl" data-id="element-214">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg" data-id="element-215">
              "I was taking so many painkillers I was worried about addiction.
              My daughter found Relievana™ online and convinced me to try it.
              Best decision I ever made. No more pills, no more morning
              stiffness, and I'm finally sleeping through the night. It's not an
              overstatement to say this saved my life."
            </p>
          </div>
          <div className="flex items-center justify-center bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-216">
            <p className="text-2xl font-bold text-blue-800 text-center" data-id="element-217">
              These aren't isolated cases. Over 30,000+ people have used
              Relievana™ to break free from the cycle of pain and sleepless
              nights.
            </p>
          </div>
        </div>
      </div>
    </section>;
};